/**
 * 100-Night Trial Page — Interactions
 * Loads AFTER haley-gentleman.js (provides reveal observer, WhatsApp pill, counter animation)
 */
(function () {
  'use strict';

  /* --- 1. Seal entrance animation --- */
  var seal = document.getElementById('nt-seal');
  if (seal) {
    seal.style.opacity = '0';
    seal.style.transform = 'scale(0.8)';
    seal.style.transition = 'opacity 1s ease, transform 1s cubic-bezier(0.16,1,0.3,1)';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        seal.style.opacity = '1';
        seal.style.transform = 'scale(1)';
      });
    });
  }


  /* --- 3. Bento card cursor-follow glow (Light Theme) --- */
  var bentoCards = document.querySelectorAll('.nt-bento__card');
  bentoCards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      card.style.background =
        'radial-gradient(circle at ' + x + 'px ' + y + 'px, rgba(0,229,255,0.08), rgba(255,255,255,0.95) 50%)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.background = '';
    });
  });

  /* --- 4. FAQ smooth open (enhance native <details>) --- */
  var faqItems = document.querySelectorAll('.hg-faq__item');
  faqItems.forEach(function (details) {
    var answer = details.querySelector('.hg-faq__answer');
    if (!answer) return;

    answer.style.overflow = 'hidden';
    answer.style.transition = 'max-height 0.35s ease, opacity 0.35s ease';

    details.addEventListener('toggle', function () {
      if (details.open) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.style.opacity = '1';
      } else {
        answer.style.maxHeight = '0';
        answer.style.opacity = '0';
      }
    });
  });

  /* --- 5. Counter animation (if not already handled by haley-gentleman.js) --- */
  var stats = document.querySelectorAll('.hg-stat[data-hg-count]');
  if (stats.length && !window.__hgCounterInit) {
    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseInt(el.getAttribute('data-hg-count'), 10);
        var numEl = el.querySelector('.hg-stat__number');
        if (!numEl || numEl.dataset.counted) return;
        numEl.dataset.counted = '1';

        var duration = 1500;
        var start = performance.now();
        function tick(now) {
          var p = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          numEl.textContent = Math.round(eased * target).toLocaleString();
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        counterIO.unobserve(el);
      });
    }, { threshold: 0.3 });

    stats.forEach(function (s) { counterIO.observe(s); });
  }

})();
